import React from "react";
import { CONTACT, waLink } from "@/data/site";
import { Phone, MessageCircle, FlaskConical } from "lucide-react";

export default function FloatingButtons({ onBook }) {
  return (
    <div className="fixed bottom-5 right-5 z-[100] flex flex-col gap-3 items-end" data-testid="floating-buttons">
      <button onClick={() => onBook && onBook()}
        aria-label="Book a Test"
        className="group flex items-center gap-2 h-14 pl-4 pr-5 rounded-full bg-turq shadow-[0_8px_30px_rgba(0,180,216,0.45)] text-white hover:scale-105 transition-transform"
        data-testid="float-book-btn">
        <FlaskConical className="w-6 h-6" /> <span className="font-medium text-sm">Book a Test</span>
      </button>
      <a href={waLink()} target="_blank" rel="noreferrer"
         aria-label="WhatsApp"
         className="w-14 h-14 rounded-full bg-emerald-500 shadow-[0_8px_30px_rgba(16,185,129,0.45)] flex items-center justify-center text-white hover:scale-110 transition-transform animate-float"
         data-testid="float-whatsapp-btn">
        <MessageCircle className="w-7 h-7" />
      </a>
      <a href={`tel:${CONTACT.phoneRaw}`}
         aria-label="Call"
         className="w-14 h-14 rounded-full bg-navy shadow-[0_8px_30px_rgba(10,37,64,0.45)] flex items-center justify-center text-white hover:scale-110 transition-transform"
         data-testid="float-call-btn">
        <Phone className="w-6 h-6" />
      </a>
    </div>
  );
}
